import ModalProviders from '../common/providers/ModalProviders'
import CommonDrawerContextProviders from '../common/context/CommonDrawerContexts'
import MessageProvider from '../common/providers/MessageProvider'
import LoadingProvider from '../common/context/LoadingContext'
import IpRestrictProvider from '../common/context/IpRestrictContext'
import IAMContent from '../iam/IAMContent'

const IAMTabPanelWrapper = ({ children, panelProps }) => (
  <CommonDrawerContextProviders>
    <ModalProviders>
      <div className='cm-relative cm-flex-1 cm-h-full cm-overflow-y-auto cm-bg-white dark:cm-bg-gray-1050'>
        <MessageProvider>
          <IpRestrictProvider>
            <LoadingProvider>
              <IAMContent {...panelProps}>
                {children}
              </IAMContent>
            </LoadingProvider>
          </IpRestrictProvider>
        </MessageProvider>
      </div>
    </ModalProviders>
  </CommonDrawerContextProviders>
)

export default IAMTabPanelWrapper
